module.exports = __webpack_public_path__ + "img/WorkSans-Regular.8fab4f4.svg";